export * from './badge-pill.module';
export * from './badge-pill.component';
